<template>
    <div class="d-flex align-center text-center my-4">
        <v-divider class="flex-grow-1"></v-divider>

        <div class="mx-4 grey--text text--darken-2 text-caption font-weight-regular">
            <span v-if="text" v-html="text" style="font-size: 14px;"></span>
            <slot v-else></slot>
        </div>

        <v-divider class="flex-grow-1"></v-divider>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: false,
            default: ''
        }
    }
}
</script>
